"use strict";

export class Messages {
  removeMessages = (botKey) => 
    Promise.reject("This feature is not supported for web requests.");
};
